import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'
import {
    ColumnConfigMappingType, SkyNetDataGridFilterType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    FilterType,
} from 'app/enums/common.enums'

type AdditionalFeesTable = Contact & {
    additionalFeesNumber: string,
    additionalFeesStatus: string,
    validFrom: string,
    validTo: string,
    changedOn: string,
    changedBy: string,
}

// TODO-JM: in main tables we use SkyNetTableField but here ColumnConfigMappingType is used.
// we need to create one type and converter with existing configs
// that will fix TODO-DK columns type comments - IP-22610
const config: ColumnConfigMappingType<AdditionalFeesTable>[] = [
    {
        name: 'additionalFeesNumber',
        labelKey: 'ADDITIONAL_FEE',
    },
    {
        name: 'additionalFeesStatus',
        filterType: FilterType.Array,
        componentName: 'AdditionalFeesStatusEnriched',
        labelKey: 'STATUS',
    },
    {
        name: 'validFrom',
        componentName: 'DateTimeCell',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        labelKey: 'VALID_FROM',
    },
    {
        name: 'validTo',
        componentName: 'LaneDateEnriched',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        labelKey: 'VALID_TO',
    },
    {
        name: 'changedOn',
        componentName: 'DateTimeCell',
        labelKey: 'CHANGED_ON',
    },
    {
        name: 'changedBy',
        labelKey: 'CHANGED_BY',
    },
]

export default config
